module.exports = __webpack_public_path__ + "static/media/icon_128.f59e1f35.svg";